(() => {
  const offer = document.getElementById('lfe-club-offer');
  if (!offer) return;
  offer.dataset.lfeReady = 'true';

  let previousFocus = null;
  let lastOpen = 0;
  const closeButtons = offer.querySelectorAll('[data-lfe-club-close]');

  const openOffer = () => {
    if (offer.classList.contains('is-active') || Date.now() - lastOpen < 2000) return;
    lastOpen = Date.now();
    previousFocus = document.activeElement;
    offer.classList.add('is-active');
    offer.style.setProperty('display', 'grid', 'important');
    offer.style.setProperty('visibility', 'visible', 'important');
    offer.style.setProperty('opacity', '1', 'important');
    offer.style.setProperty('pointer-events', 'auto', 'important');
    offer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lfe-club-offer-open');
    window.setTimeout(() => offer.querySelector('.lfe-club-offer__primary')?.focus(), 80);
  };

  const closeOffer = () => {
    offer.classList.remove('is-active');
    offer.style.removeProperty('display');
    offer.style.removeProperty('visibility');
    offer.style.removeProperty('opacity');
    offer.style.removeProperty('pointer-events');
    offer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lfe-club-offer-open');
    if (previousFocus instanceof HTMLElement) previousFocus.focus();
  };

  closeButtons.forEach((button) => button.addEventListener('click', closeOffer));
  document.addEventListener('keydown', (event) => {
    if (!offer.classList.contains('is-active')) return;
    if (event.key === 'Escape') closeOffer();
    if (event.key === 'Tab') {
      const focusable = [...offer.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')].filter(el => el.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !offer.contains(document.activeElement))) {
        event.preventDefault(); last?.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !offer.contains(document.activeElement))) {
        event.preventDefault(); first?.focus();
      }
    }
  });


  document.addEventListener('submit', (event) => {
    const productForm = event.target?.closest?.('product-form');
    if (!productForm) return;
    window.setTimeout(() => {
      const error = productForm.querySelector('.product-form__error-message-wrapper:not([hidden])');
      if (!error && document.body.classList.contains('mini-cart--open')) openOffer();
    }, 1100);
  }, true);

  document.addEventListener('lfe:product-added', () => window.setTimeout(openOffer, 180));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source === 'product-form') window.setTimeout(openOffer, 180);
    });
  }

  // BOLD inserts this form asynchronously. Keep its field names and payment handlers.
  const membershipSelector = '#bold-mem-modal-93722';
  const membershipTrigger = '.membuttonclick';
  const boutiques = ['Paris 1er', 'Nice', 'Nice Premium', 'Cannes', 'Genève', 'Bordeaux', 'Saint-Tropez'];
  let membershipOpener = null;
  const observedModals = new WeakSet();
  const setAttribute = (element, name, value) => {
    if (element && element.getAttribute(name) !== value) element.setAttribute(name, value);
  };
  const isMembershipOpen = (modal) => modal.classList.contains('in') && modal.style.display !== 'none';
  const enhanceMembership = (modal) => {
    const title = modal.querySelector('#modalPlanName');
    if (title) {
      const text = title.textContent.replace(/Abonnement Premium/g, 'Adhésion au Club')
        .replace(/€199,00\s*Yearly/g, '199 € par an').replace(/\bYearly\b/g, 'par an');
      if (title.textContent !== text) title.textContent = text;
      setAttribute(modal, 'aria-labelledby', title.id);
    }
    setAttribute(modal, 'role', 'dialog');
    setAttribute(modal, 'aria-modal', 'true');
    setAttribute(modal.querySelector('.modal-header .close'), 'aria-label', 'Fermer le formulaire Club');
    const autocomplete = { firstname: 'given-name', lastname: 'family-name', email: 'email', n_76915: 'tel' };
    modal.querySelectorAll('input.form-inputs, select.form-inputs').forEach((input) => {
      const label = input.closest('.form-group')?.querySelector('label');
      if (label) {
        if (!input.id) input.id = 'lfe-club-' + input.name;
        setAttribute(label, 'for', input.id);
      }
      if (input.classList.contains('required')) setAttribute(input, 'aria-required', 'true');
      if (autocomplete[input.name]) setAttribute(input, 'autocomplete', autocomplete[input.name]);
      if (input.name === 'email') setAttribute(input, 'inputmode', 'email');
      if (input.name === 'n_76915') {
        setAttribute(input, 'type', 'tel');
        setAttribute(input, 'inputmode', 'tel');
      }
      if (input.name === 'n_76914' && label) {
        if (label.textContent !== 'Votre boutique') label.textContent = 'Votre boutique';
        setAttribute(input, 'list', 'lfe-club-boutiques');
        setAttribute(input, 'aria-describedby', 'lfe-club-boutiques-help');
        if (!modal.querySelector('#lfe-club-boutiques-help')) {
          const hint = document.createElement('p');
          hint.id = 'lfe-club-boutiques-help';
          hint.className = 'lfe-club-field-help';
          hint.textContent = boutiques.join(' · ');
          input.after(hint);
        }
        if (!modal.querySelector('#lfe-club-boutiques')) {
          const list = document.createElement('datalist');
          list.id = 'lfe-club-boutiques';
          boutiques.forEach((name) => {
            const option = document.createElement('option');
            option.value = name;
            list.append(option);
          });
          input.after(list);
        }
      }
    });
  };
  const observeMembership = (modal) => {
    if (observedModals.has(modal)) return;
    observedModals.add(modal);
    let wasOpen = false;
    const sync = () => {
      enhanceMembership(modal);
      const open = isMembershipOpen(modal);
      setAttribute(modal, 'aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('lfe-membership-open', open);
      if (open && !wasOpen) {
        // Focus the close control without opening the phone keyboard automatically.
        modal.querySelector('.modal-header .close')?.focus({ preventScroll: true });
      } else if (!open && wasOpen && membershipOpener?.isConnected) {
        membershipOpener.focus({ preventScroll: true });
      }
      wasOpen = open;
    };
    new MutationObserver(sync).observe(modal, { childList: true, subtree: true });
    new MutationObserver(sync).observe(modal, { attributes: true, attributeFilter: ['class', 'style'] });
    modal.addEventListener('keydown', (event) => {
      if (!isMembershipOpen(modal)) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        modal.querySelector('[data-dismiss="modal"]')?.click();
      } else if (event.key === 'Tab') {
        const controls = [...modal.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')]
          .filter((el) => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first?.focus();
        }
      }
    });
    sync();
  };
  let discoveryObserver;
  const discoverMembership = () => {
    const modal = document.querySelector(membershipSelector);
    if (!modal) return false;
    observeMembership(modal);
    return true;
  };
  const watchMembership = () => {
    discoverMembership();
    discoveryObserver?.disconnect();
    discoveryObserver = new MutationObserver(discoverMembership);
    discoveryObserver.observe(document.body, { childList: true, subtree: true });
    const currentObserver = discoveryObserver;
    window.setTimeout(() => currentObserver.disconnect(), 30000);
  };
  if (document.querySelector(membershipTrigger)) watchMembership();
  document.addEventListener('click', (event) => {
    const opener = event.target.closest?.(membershipTrigger);
    if (!opener) return;
    membershipOpener = opener;
    watchMembership();
  }, true);
})();
